<div class="fx-fill fx-layout-col">
  <div class="sheet-header">
    <div class="fx-layout-row fx-justify-start fx-align-baseline">
      <div class="sheet-title fx-flex-85-percent">
        <span>{{ entity?.toString() }}</span>
      </div>
      <div class="fx-flex-48">
        <div class="btn-container">
          <button (click)="closeSidePanel()" [disableRipple]="true" id="close-sheet-button" mat-icon-button
                  class="fx-layout-col fx-justify-center fx-align-center">
            <mat-icon fontSet="mdi" fontIcon="mdi-close" class="sm"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="fx-layout-row">
      <restricted-icon-button
        (onClick)="uploadSpaceDocuments()"
        icon="mdi-paperclip"
        iconClass="sm"
        [matTooltip]="'BUTTON.ATTACH_FILE' | translate"
        [permissions]="[Permission.EDIT_SPACE, Permission.CREATE_DOCUMENT]">
      </restricted-icon-button>

      <restricted-icon-button
        (onClick)="deleteSpace()"
        icon="mdi-delete"
        iconClass="sm"
        [id]="'delete-space-button'"
        [matTooltip]="'BUTTON.DELETE' | translate"
        [permissions]="[Permission.DELETE_SPACE]"
        [preconditions]="entity?.parentPath?.length > 0">
      </restricted-icon-button>
      <workflow-buttons
        [entityType]="EntityType.SPACE"
        [view]="ManualWorkflowViewEnum.SIDEPANEL"
        [selectedEntityIds]="[entity?.id]">
      </workflow-buttons>

      @if (displayAssetSheetLink) {
        <span class="fx-flex"></span>
      }

      @if (displayAssetSheetLink) {
        <div class="sheet-link">
          <span (click)="navigateToAssetSheet()"> {{ 'BUTTON.SHOW_ASSET_SHEET' | translate }} </span>
        </div>
      }
    </div>
  </div>
  <div cdk-scrollable class="sidebar-sheet fx-flex-grow">
    <div class="page-sidebar">
      <div class="form-container">
        <form-builder [eventsOrigin]="eventsOrigin"
                      [formId]="formId"
                      [displayHeader]="false"
                      [permissionsForEdition]="permissionsForEdition">
        </form-builder>
      </div>
      <div class="document-title fx-layout-row fx-justify-start fx-align-center">
        <span class="fx-flex-30-percent"> {{ 'LABEL.DOCUMENT' | translate }} </span>
        <restricted-text-button
          (onClick)="uploadSpaceDocuments()"
          [id]="'check-upload-document-button'"
          [permissions]="[Permission.EDIT_SPACE, Permission.CREATE_DOCUMENT]"
          class="btn-upload-document">
          {{ 'BUTTON.ATTACH_FILE' | translate }}
        </restricted-text-button>
      </div>
      @for (document of entity?.documents; track document) {
        <div class="document-content">
          @if (accessManager.hasAccess(Permission.EXPORT_DOCUMENT)) {
            <a (click)="downloadEntityDocument(document.id)">
              <mat-icon fontSet="mdi" fontIcon="mdi-file-outline" class="xs"></mat-icon>
              <span class="file-name-label">{{ document.name }}</span>
            </a>
          } @else {
            <span class="file-name-label">{{ document.name }}</span>
          }
          <span (click)="deleteSpaceDocument(document)"
                [permission-lock]="[Permission.EDIT_SPACE, Permission.DELETE_DOCUMENT]"
                class="delete-document-icon">
            <mat-icon fontSet="mdi" fontIcon="mdi-delete" class="xs"></mat-icon>
          </span>
        </div>
      }
    </div>
  </div>
</div>
